<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-lg-8">
        <b-form-group>
          <b-form-input required v-model="card.title"
            :state="titleValidation"
            placeholder="Title" class="form-control" invalid-feedback="Title is required"></b-form-input>
          <span class="text-danger">*</span> <span class="text-muted">Required</span>
        </b-form-group>
      </div>
      <div class="col-md-6 col-lg-4">
        <b-form-select
          v-model="card.card_type_id"
          :options="cardTypOptions"
        ></b-form-select>
      </div>
    </div>
    <h3>Card image</h3>
    <DropzoneContainer
      ref="dropzone"
      :options="dropzoneOptions"
      :uploadOnAdd="false"
      @file-added="fileAdded"
      @upload-success="uploadSuccess"
      @upload-error="uploadError">
    </DropzoneContainer>
    <div class="my-3" v-if="file && file.accepted">
      <b-button variant="primary" @click="submit" :disabled="!file.accepted">Save card</b-button>
      <span class="text-danger" v-if="!file.accepted">There's an error with the image.</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex';
import DropzoneContainer from '../../components/DropzoneContainer.vue';

export default {
  components: {
    DropzoneContainer,
  },
  data() {
    return {
      formSubmitted: false,
      card: {
        title: '',
        card_type_id: '449adace-1a6f-410f-9f04-a3a0da47bf4a',
        image: null,
      },
      cardTypOptions: [
        { value: '449adace-1a6f-410f-9f04-a3a0da47bf4a', text: 'Activity' },
        { value: '5add17f0-f5d5-4671-9475-fe73cc05a2ff', text: 'Reward' },
        { value: 'ec282e2c-d12b-4335-8870-960fe2a11e95', text: 'Music' },
        { value: '2e66317f-52c1-4750-98bb-0fae09f6129e', text: 'Exercise' },
        { value: '17a6df41-a8ae-4f83-91db-6ceba0374b1a', text: 'Game' },
        { value: 'ed107c3a-5049-41f8-a837-961117ab15d8', text: 'Review/feedback' },
        { value: '38be4357-5b39-47f0-80eb-b36ecf22404e', text: 'Greeting' },
      ],
      dropzoneOptions: {
        acceptedFiles: '.jpg,.jpeg,.png,.gif',
        resizeWidth: 400,
        resizeMimeType: 'image/jpeg',
      },
      file: null,
    };
  },

  computed: {
    ...mapState(['directUploadUrl']),

    titleValidation() {
      if (!this.formSubmitted) {
        return null;
      }
      return this.card.title.length !== 0;
    },
  },

  methods: {
    ...mapMutations(['addCards']),

    createCard() {
      axios.post('/api/v2/cards', {
        card: this.card,
      }).then((response) => {
        if (response.status === 201) {
          this.$toast.open('Card created and added to your schedule!');
          const {
            id, image, position, title,
          } = response.data.card;
          this.addCards([{
            card_id: id, image, position, title,
          }]);
          this.$refs.dropzone.reset();
          this.formSubmitted = false;
          this.card = {
            title: '',
            card_type_id: '449adace-1a6f-410f-9f04-a3a0da47bf4a',
            image: null,
          };
        }
      });
    },

    fileAdded(file) {
      this.file = file;
    },

    submit() {
      this.formSubmitted = true;
      if (this.titleValidation) {
        this.$refs.dropzone.upload();
      }
    },

    uploadSuccess({ blob }) {
      this.card.blob = blob;
      this.card.image = blob.signed_id;
      this.createCard();
    },

    uploadError() {
      this.$toast.open({
        type: 'error',
        message: 'The image could not be uploaded. Please try again',
      });
    },
  },
};
</script>
